//Production
export default {
  apiKey: "AIzaSyAcz6k-sG4EDbvF--4cE7GlWJxuu_MF93Q",
  authDomain: "whitelistbrik-b9fba.firebaseapp.com",
  databaseURL: "https://whitelistbrik-b9fba.firebaseio.com",
  projectId: "whitelistbrik-b9fba",
  storageBucket: "whitelistbrik-b9fba.appspot.com",
  messagingSenderId: "1036481851649"
  };

// end production

//Staging ---------------------------------------------------
/*
export default {
    apiKey: "AIzaSyAt3hUQBCeDOn3dEHy6Cc77q-1XJcEyjXE",
    authDomain: "stage-brik.firebaseapp.com",
    databaseURL: "https://stage-brik.firebaseio.com",
    projectId: "stage-brik",
    storageBucket: "stage-brik.appspot.com",
    messagingSenderId: "789496249996"
  };
// end staging ----------------------------------------------
*/


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js